import { fromZonedTime } from 'date-fns-tz'

export const useAnnouncementSchedule = () => {
	const config = useRuntimeConfig()
	const timeZone = 'Australia/Melbourne'

	const startDate = config.public.ANNOUNCEMENT_START_DATE
	const endDate = config.public.ANNOUNCEMENT_END_DATE

	if (!startDate || !endDate) {
		return {
			showAnnouncement: computed(() => false),
			hasAnnouncementEnded: computed(() => false),
		}
	}

	const announcementStartDate = fromZonedTime(startDate, timeZone)
	const announcementEndDate = fromZonedTime(endDate, timeZone)

	const showAnnouncement = computed(() => {
		const now = new Date()
		return now >= announcementStartDate && now <= announcementEndDate
	})

	const hasAnnouncementEnded = computed(() => {
		const now = new Date()
		return now >= announcementEndDate
	})

	return { showAnnouncement, hasAnnouncementEnded }
}
